import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import API, { handleApiError } from '../../../lib/api';
import AdminMortgageView from './View';
import AdminMortgageNotFound from '../AdminMortgageNotFound';

import Loading from '../../common/Loading';

function AdminMortgageContainer({ id }) {
  const mortgageId = id;
  // Data state to store the users data. Its initial value is an empty array
  const [data, setData] = useState([]);
  const [displayError, setDisplayError] = React.useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    await API.get(`mortgages/${mortgageId}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        handleApiError({ error, setDisplayError });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!mortgageId) {
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mortgageId]);

  if (isLoading) return <Loading />;
  return data && data._id ? (
    <AdminMortgageView
      data={data}
      refetchData={fetchData}
      setDisplayError={setDisplayError}
      displayError={displayError}
    />
  ) : (
    <AdminMortgageNotFound id={mortgageId} displayError={displayError} />
  );
}

AdminMortgageContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default AdminMortgageContainer;
